// Sources whose conversations are allowed to be viewed on the chat page.
// Other sources (optimizer, alert responder, etc.) contain internal prompting
// that should not be exposed.
export const CHAT_VIEWABLE_SOURCES = new Set(["UI", "SLACK", "API", "MCP_CLIENT", "STUDIO", "LINEAR"]);
